import { useEffect, useRef } from 'react';

const eventTypes = ['click', 'touchstart'];
const ignoreClassName = 'ignore-onclickoutside';

const hasIgnoreClassName = (target) => {
  let node = target;

  // Traverse up the DOM tree from the current node
  while (node !== null && node !== document) {
    if (node.classList.contains(ignoreClassName)) {
      return true;
    }
    // Move up to the parent node
    node = node.parentNode;
  }

  return false;
};

const isTargetOutsideRef = (target, ref) => {
  if (ref.current) {
    return !ref.current.contains(target) && !hasIgnoreClassName(target);
  }

  return false;
};

function useOnClickOutside(ref, handler, { enabled = true } = {}) {
  const savedHandler = useRef(handler);
  savedHandler.current = handler;

  useEffect(() => {
    const listener = (event) => {
      const { target } = event;

      if (!target || !target.isConnected) return;

      const isOutside = Array.isArray(ref)
        ? ref.every((r) => isTargetOutsideRef(target, r))
        : isTargetOutsideRef(target, ref);

      if (isOutside) {
        savedHandler.current(event);
      }
    };

    if (enabled) {
      eventTypes.forEach((eventType) => {
        document.addEventListener(eventType, listener);
      });
    }

    // Remove event listeners on cleanup
    return () => {
      if (enabled) {
        eventTypes.forEach((eventType) => {
          document.removeEventListener(eventType, listener);
        });
      }
    };
  }, [enabled]);
}

export default useOnClickOutside;
